
const state = {
    sourceMaterialState: false,
    secondPanelData: {
        label: "",
        key: 0,
        id: "",
        data: {},
    },
}
const getters = {
    sourceMaterialState: state => state.sourceMaterialState,
    secondPanelData: state => state.secondPanelData,
}

const mutations = {
    setSourceMaterialStates(state, data) {
        state.sourceMaterialState = data.state
    },

    setSecondPanelData(state, data) {
        state.secondPanelData = data
    },

}
export default {
    namespaced: true,
    state,
    getters,
    mutations
};




// WEBPACK FOOTER //
// ./src/store/modules/resourcesArea/sourceMaterial.js